module.exports = __webpack_public_path__ + "static/media/cdb6.e5137323.png";